import { getArticles } from "@/services/articles";
import type { ArticlesGetOptions, Article } from "@/services/articles";
import { useLoading } from "./loading";

export function useArticles() {
  const loading = useLoading();
  const articles = ref<Article[]>([]);
  const error = ref<string>();

  async function load(options: ArticlesGetOptions): Promise<Article[] | void> {
    loading.start();
    error.value = undefined;

    return getArticles(options)
      .then((articlesList) => {
        articles.value = articlesList;
        loading.stop();
        return articles.value;
      })
      .catch((error) => {
        error.value = error.message ?? error;
        loading.stop();
        throw error;
      });
  }

  return {
    load,
    articles,
    error,
    loading,
  };
}
